import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { monitorBtnKeys } from "../automationKeys";

import { StyledMonitorBtnWrapper } from "./styles";
import { MONITOR_TOPICS, OWNER_NOT_CREATE_ANY_TOPIC } from "./texts";

type MonitorTopicsButtonSchema = { onClick(): void; isViewerMode?: boolean };

export const MonitorTopicsButton = ({ onClick, isViewerMode = false }: MonitorTopicsButtonSchema) => (
    <StyledMonitorBtnWrapper data-automation={monitorBtnKeys.container}>
        <PlainTooltip
            tooltipContent={translate(OWNER_NOT_CREATE_ANY_TOPIC)}
            enabled={isViewerMode}
        >
            <span>
                <IconButton
                    onClick={onClick}
                    iconName="add-to-group"
                    isDisabled={isViewerMode}
                >
                    {translate(MONITOR_TOPICS)}
                </IconButton>
            </span>
        </PlainTooltip>
    </StyledMonitorBtnWrapper>
);
